import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

const MenuSubItemContainer = styled.div`
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: ${themeColors.colorBackgroundPrimary}};
  `;

const MenuSubItemTitleWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1.25rem 0 0;
  margin-left: 2.25rem;
  text-decoration: ${(props) => (props.checked ? 'line-through' : 'none')};
  font-weight: ${(props) => (props.isActive ? 600 : 400)};
`;

const MenuSubItemSymbol = styled.span`
  margin-right: 1.25rem;
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
`;

const MenuSubItemTitle = styled.div`
  text-decoration: ${(props) => (props.checked ? 'line-through' : 'none')};
`;

const MenuSubItem = ({ title, checked, isActive }) => {
  if (!title) {
    return null;
  }

  return (
    <MenuSubItemContainer>
      <MenuSubItemTitleWrap isActive={isActive}>
        <MenuSubItemSymbol isActive={isActive}>&#124;</MenuSubItemSymbol>
        <MenuSubItemTitle checked={checked}>{title}</MenuSubItemTitle>
      </MenuSubItemTitleWrap>
    </MenuSubItemContainer>
  );
};

MenuSubItem.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default MenuSubItem;
